import angular from 'angular';
import tableGridErrorReportCellComponent from './tableGridErrorReportCell.component';

let tableGridErrorReportCellModule = angular.module('tableGridErrorReportCell', []).directive('tableGridErrorReportCell', tableGridErrorReportCellComponent);

export default tableGridErrorReportCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridErrorReportCell/tableGridErrorReportCell.js